import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Terminal() {
  return (
    <PageLayout
      title="Customer-Present Cloud"
      subtitle="Take EMV payments in person with 100% browser-based point of sale systems."
      badge="HARDWARE READY"
      imageSrc="/products/art_terminal_1776905136585.png"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16">
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Cloud EMV Framework</h3>
          <p className="text-gray-600 mb-6">Break free from legacy tethered card readers. Our cloud terminal framework allows any internet-connected device—whether it's a tablet, PC, or smart fridge—to command a physical card reader securely.</p>
        </div>
        
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">P2PE Encryption</h3>
          <p className="text-gray-600 mb-6">All card-present transactions utilize Point-to-Point Encryption (P2PE), ensuring sensitive data is completely obfuscated before it ever hits your local network, reducing physical PCI scope.</p>
        </div>
      </div>
    </PageLayout>
  );
}
